import styled from '@emotion/styled';
import { formatTimeDuration } from '@racemap/utilities/formattings/formatting';
import { formatSpeed } from '@racemap/utilities/formattings/units';
import {
  type Geofence,
  type PreparedStarterInfo,
  sortTimes,
  testEventHasVirtDuration,
} from '@racemap/utilities/functions/timing';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { Column } from '../TableBody';
import { DoubleCell } from './BasicCell';
import { LARGE_TIME_COL_WIDTH, SMALL_TIME_COL_WIDTH } from './TimesCol';

function ActiveDurationColComponent({
  starterInfo,
  event,
}: {
  starterInfo: Immutable<PreparedStarterInfo>;
  event: Immutable<RacemapEvent>;
}) {
  const eventHasVirtDuration = testEventHasVirtDuration(event);
  const unitType = event.playerOptions.unitType;
  const activeDuration = starterInfo?.activeDuration;

  return (
    <DoubleCell>
      <div>{activeDuration && activeDuration > 0 ? formatTimeDuration(activeDuration) : ''}</div>
      {!eventHasVirtDuration && activeDuration && (
        <Speed>{formatSpeed(starterInfo?.progress / activeDuration, unitType)}</Speed>
      )}
    </DoubleCell>
  );
}

export function getActiveDurationCol(
  event: Immutable<RacemapEvent>,
  timekeepings: Immutable<Array<Geofence>>,
  windowWidth: number,
): Column {
  const eventHasVirtDuration = testEventHasVirtDuration(event);

  return {
    key: 'times_finish',
    title: 'Active Duration',
    width:
      windowWidth < 990 || timekeepings.length > 6 ? SMALL_TIME_COL_WIDTH : LARGE_TIME_COL_WIDTH,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <ActiveDurationColComponent event={event} starterInfo={row} />;
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) =>
      eventHasVirtDuration
        ? (b?.activeDuration || 0) - (a?.activeDuration || 0)
        : sortTimes(b?.activeDuration, a?.activeDuration),
  };
}

const Speed = styled.div`
  opacity: 0.7;
  font-size: 10px;
`;
